import React, { useState, useEffect } from "react";
import { OpenAIApi } from "openai";
import { Configuration } from "openai";
const REACT_APP_OPENAI_KEY = process.env.REACT_APP_OPENAI_KEY;

function Chores() {
  const [promptNames, setPromptNames] = useState("");
  const [promptDate, setPromptDate] = useState("");


  const [result, setResult] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  // DEFINING OPENAI------------------------------------------------------------------------------
  const configuration = new Configuration({
    apiKey: REACT_APP_OPENAI_KEY,
    "User-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10",
  });
  const openai = new OpenAIApi(configuration);
  //DEFINING OPENAI-----------------------  --------

  // GETTING INPUT VALUES--------------------------------------------

  const handleInputNames = (text) => {
    setPromptNames(text);
    console.log("HANDLE INPUT NAMES:", text);
  };




  const saveFile = (variable1, variable2) => {
    let prompt = document.querySelector('#prompt').innerHTML
  let response = document.querySelector('#response').innerHTML
   const saveData = { prompt, response };
    const blob = new Blob([JSON.stringify(saveData)], { type: 'application/json'}); 
    const url = window.URL.createObjectURL(blob);
     const a = document.createElement('a');
      a.href = url;
      a.download = 'variables.json'; 
     a.click(); window.URL.revokeObjectURL(url); }





  const handleDate = (text) => {
    setPromptDate(text);
    console.log("HANDLE DATE INPUT: ", text);
  };

  const handleInputChange = (text) => {
    setPromptNames(text);
  };

  // DONE GETTING INPUT VALUES--------------------------------------

  // USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//
  useEffect(() => {
    // KEEPS TRACK OF NAME CHANGES//
    console.log("USE EFFECT HOOK PROMPT NAMES : ", promptNames);
    const listenClickName = document.getElementById("userInputFieldNames");
    console.log(handleInputChange.value);
    listenClickName.addEventListener("click", (e) => {
      console.log("User has clicked into the Name box");
    });
    // KEEPS TRACK OF DATE CHANGES//
    console.log(" USE EFFECT HOOK PROMPT DATE: ", promptDate);
    const listenClickDate = document.getElementById("userInputFieldDate");
    console.log(handleInputChange.value);
    listenClickDate.addEventListener("click", (e) => {
      console.log("User has clicked into the Date box");
    });

    listenClickName.addEventListener("keydown", handleInputChange);
  }, [promptNames, promptDate]);
  // USE EFFECT HOOK ___________________----===================----USE EFFECT HOOK ________________//

  const output = document.getElementById("output");

  // MAIN FUNCTION WHEN BUTTON IS CLICKED TO SUBMIT-------------------------------------------
  const generateChores = async () => {
    setIsLoading(true);
    // let pn = promptNames.replace(/\w+$/, 'and $&');
    console.log(
      "SENDING",
      promptDate,
      "AS MONDAYS START DATE, AND",
      promptNames,
      "AS THE PEOPLE INCLUDED IN THE CHART to the prompt!!!"
    );
    try {
      console.log("generateChores was called, and is now in the try block");

      const res = await openai.createCompletion({
        // This was the latest one before the modification. to keep things simple, just come back to this prompt prefix if shit get hairy
        //  prompt: `

        //  For each day of the week starting with ${promptDate}, list a chore, a points value, a fun fact, and an inspirational quote for each person named
        //  ${promptNames}. Label each date as a header before naming the chores for each person. After the last name on the first day is completed, begin the second day with a new set; continue for all 7 days..

        //  //  Response Format:
        // //  <ul>
        // //   <h1>
        // //   Date
        // //   </h1>

        // //         <li class="line"></li>
        // // <li>Name</li>
        // //   <li> Chore:</li>
        // //   <li>Time to complete: </li>
        // //   <li>Incentive:</li>
        // //   <li> Fun Fact:</li>
        // //   <li>Inspirational Quote: </li>
        // // </ul>
        // // <ul>

        // ***Use the format for each person in the ${promptNames}....
        // There MUST be 7 days, (Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday) in your response starting with ${promptDate}..
        // You are forbiden to response with an incomplete chart that has no more or less than exactly 7 days
        // ****

        // note: if oct 5 starts the week, oct 5th, 6th, 7th, 8th, 9th, 10th, and 11th must be listed. if nov 17 starts the week, the 17th-24th MUST be listed...etc..***THERE MUST BE 7 DAYS COMPLETED IN YOUR RESPONSE FOR THIS CHART****

        // after you have completed the 7 days and provided the response, include  a peppy pep talk to get the week started with excitement and optimism.
        // `,

        prompt: `

Write in jsonx format, a set of training data that will train and test a specific use case to use with openai. The use case will be to make chore charts. the chore charts will ALWAYS be 7 days long. The charts will NEVER be more than 7 days, or less than 7 days. When names are fed to the prompt via end user when the AI is live, there will be a set of key:values that will go with EVERY name that is provided for EACH day of the SEVEN day week that you will neatly be responding with when you recieve the names and the chore week's start date. The start date can be passed in whichever form is is recieved to you in in the request. If there is a typo, fix it, but this should be rare. 

Start with the training data that will fine tune the model and keep the cost of use down when people start catching on and using the chore chart each week. 

The output must be formatted in an HTML5 document and include headers/a table/lists/breaks/emphasis where the self explanatory locations are in a modern, sleek document. 

For each person on each day there must be a chore, and points value, a time limit, an incentive if a difficult or at least full energy/concentration task is completed successfully (task needs to be creatively provided as well). A fun fact for all ages. Each person on each day must also hace an inspirational quote to go with the day. There should be a week long motto that is boldly and correctly displayed with the data, and a peppy little pep talk that becomes personal to the members' of the chores that would at the very least, crack some smiles. The last day needs to have a sections for tallying all points and wrapping up the month .


training data:

textarea waiting on end user asking for names: 
user inputs: ${promptNames}
textarea waiting on end user asking for week start date(Monday's data):${promptDate}

Responses in order:
1)Chore Chart:
2)Your response as directed from data provided by end user (AKA Chore Chart Leader): `,

        model: "text-davinci-003",
        max_tokens: 3463,
        temperature: 0.84,
      });


      setResult(res.data);

      console.log(setResult);

      console.log("RES.DATA :", res.data.choices[0].text);
      if (output) {
        output.innerHTML = res.data.choices[0].text;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(
        "FROM 'generateChores', in the catch block, THE ERROR IS RELATED TO: ",
        error
      );
    }
    console.log("You did it bud, carry on");
    console.log("RESULT :", result);
  };

  //  RETURN AKA FRONTEND --------------------------------

  return (
    <div className="App">
      {/* HEADER-------- */}
      <header>
        <div className="line"></div>
        <h1 className="header-content">
          Create this week's chores 👎
          <br /> and inspirations 👍
        </h1>
        <br />
        <div className="line"></div>
      </header>


      <section>
        <textarea
          id="userInputFieldNames"
          title="Separate the names with commas and include as many as you want"
          className="content-col ff fit text lead"
          placeholder="Names for this weeks chart"
          onChange={(e) => {
            handleInputNames(e.target.value);
            setPromptNames(e.target.value);
          }}
        />

        <br />
        <br />

 
        <textarea
          id="userInputFieldDate"
          className="content-col fff ff text fit"
          title="Use any standard date format this this"
          placeholder="Chart start date"
          onChange={(e) => {
            handleDate(e.target.value);
            setPromptDate(e.target.value);
          }}
        />
      </section>
      <button className="btn" onClick={generateChores}>
        {isLoading ? (
          <span className="btn">
            <i className="fa fa-spinner fa-spin loader" />{" "}
            {`Generating Chores for the week for ${promptNames} `}
        
          </span>
          
        ) : isError ? (
          "Error"
        ) : (
          "Complete" 
        )}
      </button>

 
      <section id="output">
        <div id="returnedFromAi" className="col">
          {result || result.length > 0 ? (
            <div className="explore result">
              <p className="no-over" id="output no-over result-text returnedFromAi">
                {result.choices[0].text}
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      </section>

      <a className="back-link" href="/">
        back home
      </a>

      <a href="/openai/m1/select" className="back-link">
        Try something else
      </a>

      {/* LAST DIV---- */}


      
    </div>
  );
}

export default Chores;
